// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"buildcontrol_BuildControl__3iPaE","Label":"buildcontrol_Label__13iD7","Less":"buildcontrol_Less__MNi1V","More":"buildcontrol_More__3Ijiw"};